import { render, staticRenderFns } from "./ManutencaoNotaFiscalModallidadeFrete.vue?vue&type=template&id=3719df16"
import script from "./ManutencaoNotaFiscalModallidadeFrete.vue?vue&type=script&lang=js"
export * from "./ManutencaoNotaFiscalModallidadeFrete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports